var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMembersActivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 48,
    viewBox: "0 0 64 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10458_61548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17603 44.1223C6.17603 44.653 6.58688 44.9664 7.03705 44.9664H56.0905C56.5471 44.9664 56.958 44.653 56.958 44.1223C56.958 43.5982 56.5471 43.2781 56.0905 43.2781H7.03705C6.58688 43.2781 6.17603 43.5982 6.17603 44.1223Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5688 38.5819C45.5688 39.6732 46.2866 40.3443 47.4414 40.3443H53.7219C54.8364 40.3443 55.5947 39.6732 55.5947 38.5819V21.1631C55.5947 20.0888 54.8364 19.3943 53.7219 19.3943H47.4414C46.2866 19.3943 45.5688 20.0888 45.5688 21.1631V38.5819Z",
    fill: "#0066FF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8879 38.5818C32.8879 39.6731 33.6292 40.3442 34.7269 40.3442H41.041C42.1622 40.3442 42.9202 39.6731 42.9202 38.5818V10.2988C42.9202 9.22441 42.1622 8.53656 41.041 8.53656H34.7269C33.6292 8.53656 32.8879 9.22441 32.8879 10.2988V38.5818Z",
    fill: "#0066FF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1968 38.5819C20.1968 39.6731 20.9314 40.3442 22.0629 40.3442H28.3498C29.4813 40.3442 30.2225 39.6731 30.2225 38.5819V4.76234C30.2225 3.68797 29.4813 3.00012 28.3498 3.00012H22.0629C20.9314 3.00012 20.1968 3.68797 20.1968 4.76234V38.5819Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53296 38.5818C7.53296 39.6731 8.25731 40.3441 9.40561 40.3441H15.686C16.7904 40.3441 17.5652 39.6731 17.5652 38.5818V15.8212C17.5652 14.7534 16.7904 14.059 15.686 14.059H9.40561C8.25731 14.059 7.53296 14.7534 7.53296 15.8212V38.5818Z",
    fill: "#0066FF",
    fillOpacity: 0.55
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10458_61548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.6475,
    height: 42,
    fill: "white",
    transform: "translate(6.17627 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersActivity);
export default __webpack_public_path__ + "static/media/members-activity.d61cb7e10e72d780ea94d8830e8dfcaf.svg";
export { ForwardRef as ReactComponent };